import Vue from 'vue';
import VatsAPI from '@/Shared/VatsAPI';
import { AxiosResponse } from 'axios';

const PollingMixin = Vue.extend({
    props: {
        pollUrl: {
            type: String,
            required: true,
        },
        pollParams: {
            type: Object
        },
        completionRouteName: {
            type: String,
            required: false,
        }
    },
    computed: {
    },
    data() {
        return {
            loading: false,
            error: false,
            retryCount: 3,
            success: false
        };
    },
    methods: {
        async poll(): Promise<AxiosResponse> {
            const result = await VatsAPI.get<string>(this.pollUrl, {
                headers: {
                    accept: 'application/json',
                },
                params: {
                    ...this.pollParams,
                    waitCount: 20
                }
            });

            return result;
        },
        async awaitCompletion() {
            this.loading = true;
            let result = null;
            let success = false;

            for (let i = 0; i < this.retryCount && !success; i++) {
                try {
                    result = await this.poll();
                    success = true;
                }
                catch (e) {
                    success = false;
                }
            }

            this.loading = false;

            if (success) {
                this.success = true;

                this.$emit('pollingSuccess', result!.data);

                if (this.completionRouteName) {
                    await this.$router.push({
                        name: this.completionRouteName,
                        params: { responseId: result!.data as any }
                    });
                }
                else {
                    // todo: success message
                }
            }
            else {
                this.error = true;
            }
        }
    }
});

export default PollingMixin;
